import { render, staticRenderFns } from "./svgs.vue?vue&type=template&id=38fa7b3f&"
import script from "./svgs.vue?vue&type=script&lang=js&"
export * from "./svgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports